<template>
  <div class="container">
    <div class='content'>
      <p class="img"></p>
    <div class="info_text">
      <p>
        1、开通月卡的用户最低可获得450个钻石，订阅周期可选:月、季、年等，用户可以根据需要自行选择
      </p>
      <p>
        2、苹果手机用户在 APP Store官方订阅功能通过
        Itunes账户进行确认支付。用户可手动在 Tunes/ Apple
        ID设置管理中关闭自动续订功能
      </p>
      <p>
        3、连续包月{{this.price}}，您可随时取消连续包月/季年服务，取消后不会再自动续费。开通自动续费将于到期前24小时从您的
        itunes l账户中扣费，扣费成功后顺延一个订阅期
      </p>
      <p>
        4、苹果手机用户如需取消订，请手动打开苹果手机“设置”ー＞进入“
        Itunes和Aptore＂-＞点击“ Apple ID＂，选择“查看 Apple
        ID＂，进入“账户设置”页点击“订阅”，选择我是谜月卡取消订阅即可。如未在订阅期结束的24小时前关闭订阅，此订阅将会自动续订
      </p>
      <p>
        5、月卡自动续费服务规则:<a href="https://meitu.mvoicer.com/server_rules"
          >https://meitu.mvoicer.com/server_rules</a
        >
      </p>
      <p>
        6、隐私政策及声明:<a href="http://server.mvoicer.com/terms.html"
          >http://server.mvoicer.com/terms.html</a
        >
      </p>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      price: "",
    };
  },
  created() {
    this.price = "30/月、90/季、365/年";
    document.getElementsByTagName("title")[0].innerText = "月卡说明";
    var u = navigator.userAgent;
    var isAPP = new RegExp("WSMAPP WSM").test(u);
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAPP) {
      if (isAndroid) {
        this.price = "30/月、90/季、365/年";
      }else{
        this.price = "28/月、78/季、318/年";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/base.css");
.container {
  width: 100vw;
  height: 100vh;
  padding-top: 0.6rem;
  background:rgba(246,247,250,1);
  .content{
    width:17.55rem;
    margin-left:auto;
    margin-right:auto;
    background:rgba(255,255,255,1);
    height: 100vh;
    border-radius: 0.25rem 0.25rem 0 0;
    .img {
    background: url("../assets/images/month_info.png") no-repeat;
    background-size: cover;
    width: 100%;
    height: 3.4rem;
  }
  .info_text {
    text-align: left;
    font-size: 0.6rem;
    font-family: "PingFangSC-Medium,PingFang SC";
    font-weight: 500;
    color: rgba(87, 86, 90, 1);
    line-height: 0.9rem;
    padding-left: 0.6rem;
    padding-right: 0.6rem;
    padding-top:0.75rem;
    p {
      a {
        color: rgba(87, 86, 90, 1);
      }
      a:link {
        color: rgba(87, 86, 90, 1);
      }
      /*已经访问过的链接*/
      a:visited {
        color: rgba(87, 86, 90, 1);
      }
      /*鼠标划过(停留)的链接*/
      a:hover {
        color: rgba(87, 86, 90, 1);
      }
      /* 正在点击的链接*/
      a:active {
        color: rgba(87, 86, 90, 1);
      }
    }
  }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/monthtext.vue